// Interim single-program id. Prime resolves the active program from this stub
// server-side until RVL-3274 implements real active-program resolution; the FE
// mirrors that convention for the agency-scoped incentive_programs endpoints.
export const INCENTIVE_PROGRAM_STUB_ID = '00000000-0000-0000-0000-000000000001';
